import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';
import { ISoil } from '../../shared/iProject';

const initialState: IReduxState<ISoil[]> = {
    status: EReduxState.initialState,
};

export const soilSlice = createSlice({
    name: 'soil',
    initialState,
    reducers: {
        cleanSoil: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setSoil: (state, action: PayloadAction<ISoil[]>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { cleanSoil, setSoil } = soilSlice.actions;

export const selectSoil = (state: RootState) => state.soil;

export default soilSlice.reducer;
